<template>
  <popup-modal ref="popup">
    <!-- Main modal -->
    <div
      class="relative mx-auto shadow-lg rounded-md bg-white dark:bg-gray-800 overflow-y-auto"
      style="max-height: 95vh"
    >
      <div class="mt-3">
        <!-- Close Button -->
        <button
          type="button"
          class="text-gray-400 absolute top-2.5 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
          @click="_cancel"
        >
          <svg
            aria-hidden="true"
            class="w-5 h-5"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <span class="sr-only">Close modal</span>
        </button>

        <div class="h-2"></div>

        <!-- Named body slot -->
        <slot name="body" />

        <!-- Default slot (for backward compatibility) -->
        <slot />

        <!-- Named footer slot -->
        <div v-if="$slots.footer" class="mt-4 px-4 pb-4">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </popup-modal>
</template>

<script>
import PopupModal from "./PopupModal.vue";

export default {
  name: "ConfirmDialogue",
  components: { PopupModal },

  data: () => ({
    title: undefined,
    message: undefined,
    okButton: undefined,
    cancelButton: "پاشگەزبوونەوە",

    resolvePromise: undefined,
    rejectPromise: undefined,
  }),

  methods: {
    show(opts = {}) {
      this.title = opts.title;
      this.message = opts.message;
      this.okButton = opts.okButton;
      if (opts.cancelButton) {
        this.cancelButton = opts.cancelButton;
      }
      this.$refs.popup.open();
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    hide() {
      this.$refs.popup.close();
    },
    _confirm() {
      this.$refs.popup.close();
      this.resolvePromise(true);
    },
    _cancel() {
      this.$refs.popup.close();
      this.resolvePromise(false);
    },
  },
};
</script>
